import styled from 'styled-components/macro'
import {Blue, Blue_800, White, Gray_200, Gray_500, Gray_Dark} from '../../../constants/colors'

export const Button = styled.button`
	color: ${props => props.color ? props.color : White };
	border: ${props => props.border && props.border };
	border-color: ${props => props.borderColor && props.borderColor };
	background: ${props => props.background ? props.background : Blue };
	padding: ${props => props.padding ? props.padding :"11px 16px" };
	cursor: pointer;
	font-size: ${props => props.fontSize ? props.fontSize :"14px" };
	line-height: 16px;
	outline: none;
	font-weight: 600;
	width: ${props => props.width ? props.width :"100%" };
	-webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
	&:hover {
		background: ${props => props.hoverBackground ? props.hoverBackground : 'Green' };
		color: ${props => props.hoverColor ? props.hoverColor : 'White' };
	}
	&:disabled {
		color: ${Gray_Dark};
		background: ${Gray_200};
		border-color: ${props => props.disabledBorder ? props.disabledBorder : Gray_200 };
	}
	@media only screen and (min-width: 769px) {
        border-radius: 2px;
    }
`
export const ButtonPrimary= styled.button`
	background: ${props => props.background ? props.background : Blue_800 };
`

export const ButtonSecondary= styled.button`
	background: ${props => props.background ? props.background : Blue };
`